import { InferType, object, string } from "yup";

export type IFormularioNFeIntegracaoSchema = InferType<
  typeof formNFeIntegracaoSchema
>;

export const formNFeIntegracaoSchema = object({
  empresaId: string().required(),
  origemSimplificada: string()
});
